import MedicationAnswer from "../abstract/MedicationAnswer"
import BoolQuestionAnswerStrategy from "../abstract/BoolQuestionAnswerStrategy"
import MedicationQuestion from "../abstract/MedicationQuestion"
import QuestionCreator from "../abstract/QuestionCreator"

export enum PatientPreConditions {
    v1="v1",
    v2="v2",
    v3="v3",
    v4="v4",
    v5="v5",
    v6="v6",
    v7="v7",
    v8="v8",
    v9="v9",
    v10="v10",
    v11="v11",
    v12="v12",
    v13="v13",
    v14="v14",
    v15="v15",
    v16="v16",
    v17="v17",
    v18="v18",
    v19="v19",
    v20="v20",
    v21="v21",
}

export const PatientPreConditionQuestions: Record<PatientPreConditions, string> = {
    [PatientPreConditions.v1]: "Wird ein Benzodiazepin seit mehr als 4 Wochen verordnet?",
    [PatientPreConditions.v2]: "Bekannte QT-Verlängerung oder entsprechende Risikofaktoren (Herzmuskelhypertrophie, Bradyarrhythmie, ständige Neigung zu Hypokaliämie, etc.)",
    [PatientPreConditions.v3]: "Unkontrollierte Hypertonie",
    [PatientPreConditions.v4]: "Herzinsuffizienz",
    [PatientPreConditions.v5]: "Tachykardie in den letzten 6 Monaten",
    [PatientPreConditions.v6]: "Zustand nach Schlaganfall",
    [PatientPreConditions.v7]: "Ischämische Herzkrankheit (z.B. KHK, Angina pectoris, Myokardinfarkt)",
    [PatientPreConditions.v8]: "Demenz",
    [PatientPreConditions.v9]: "Zustand nach Delir",
    [PatientPreConditions.v10]: "Kognitive Beeinträchtigungen",
    [PatientPreConditions.v11]: "Persistierende Schlaf- (z.B. Insomnie, Restless legs) und Unruhestörungen in den letzten 6 Monaten",
    [PatientPreConditions.v12]: "Erste Episode einer leichten Depression",
    [PatientPreConditions.v13]: "Erste Episode einer mittelgradigen Depression",
    [PatientPreConditions.v14]: "Handelt es sich um eine erste Episode einer (mittelgradigen oder) schweren Depression?",
    [PatientPreConditions.v15]: "Miktionsstörungen (Harnverhalt, BPH, …) in den letzten 6 Monaten",
    [PatientPreConditions.v16]: "Gastrointestinale Erkrankungen (Ulkus, Blutung, ...)",
    [PatientPreConditions.v17]: "Aktive Lebererkrankungen oder Zirrhose",
    [PatientPreConditions.v18]: "Zustand nach einer non-GI-Blutung oder Hämophilie",
    [PatientPreConditions.v19]: "Engwinkelglaukom in den letzten 6 Monaten",
    [PatientPreConditions.v20]: "Hyponatriämie (<130 mmol/l) in den letzten 6 Monaten",
    [PatientPreConditions.v21]: "Erhöhte Serumtransaminasewerte (>3-facher oberer Normalbereich) unter Behandlung mit Agomelatin"
}

export interface PreConditionSection {
    title?: string,
    preconditions: PatientPreConditions[]
}

export const PatientPreConditionSections: PreConditionSection[] = [
    {
        preconditions: [PatientPreConditions.v1],
        title: "Einnahmedauer bei Benzodiazepinen",
    },
    {
        title: "Kardiovaskuläre Erkrankungen",
        preconditions: [
            PatientPreConditions.v2,
            PatientPreConditions.v3,
            PatientPreConditions.v4,
            PatientPreConditions.v5,
            PatientPreConditions.v6,
            PatientPreConditions.v7
        ] },
    {
        title: "Neurologische/ psychische Erkrankungen",
        preconditions: [
            PatientPreConditions.v8,
            PatientPreConditions.v9,
            PatientPreConditions.v10,
            PatientPreConditions.v11,
            //PatientPreConditions.v12,
            //PatientPreConditions.v13,
            //PatientPreConditions.v14,
        ]},
    {
        title: "Sonstige Erkrankungen/ Störungen",
        preconditions: [
            PatientPreConditions.v15,
            PatientPreConditions.v16,
            PatientPreConditions.v17,
            PatientPreConditions.v18,
            PatientPreConditions.v19,
        ]},
    {
        title: "Laborwerte",
        preconditions: [
            PatientPreConditions.v20,
            PatientPreConditions.v21
        ]}
]

const PatientHasPreCondition =
    (
        condition: PatientPreConditions,
        answer: MedicationAnswer,
        optional: {
            strategy: BoolQuestionAnswerStrategy
            followedBy?: MedicationQuestion
            alternativeAnswer?: MedicationAnswer
        } = { strategy: BoolQuestionAnswerStrategy.ON_YES }
    ): QuestionCreator =>
        (input) =>
            new MedicationQuestion(
                PatientPreConditionQuestions[condition],
                input
            ).answerAutomatically((input) => {
                const fulfilled: boolean = input.preconditions[condition]
                if (fulfilled) {
                    return optional.strategy === BoolQuestionAnswerStrategy.ON_YES
                        ? answer
                        : optional.alternativeAnswer
                            ? optional.alternativeAnswer
                            : new MedicationAnswer("Ja")
                }
                return optional.strategy === BoolQuestionAnswerStrategy.ON_NO
                    ? answer
                    : optional.alternativeAnswer
                        ? optional.alternativeAnswer
                        : new MedicationAnswer("Nein")
            })

export default PatientHasPreCondition